'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _utils = require('./utils');
var _utils2 = _interopRequireDefault(_utils);
var _icons = require('./icons');
var _icons2 = _interopRequireDefault(_icons);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var Controller = function () {
    function Controller(player) {
        _classCallCheck(this, Controller);
        this.player = player;
        this.initPlayButton();
        this.initList();
        this.initPlayBar();
        if (this.player.isMultiple()) {
            this.initOrderButton();
        }
        this.initLoopButton();
        this.initMenuButton();
        if (!_utils2.default.isMobile) {
            this.initVolumeButton();
        }
    }
    _createClass(Controller, [
        {
            key: 'initPlayButton',
            value: function initPlayButton() {
                var _this = this;
                this.player.template.pic.addEventListener('click', function () {
                    _this.player.toggle();
                });
            }
        },
        {
            key: 'initList',
            value: function initList() {
                var _this2 = this;
                this.player.template.list.addEventListener('click', function (e) {
                    var target = void 0;
                    if (e.target.tagName.toUpperCase() === 'LI') {
                        target = e.target;
                    } else {
                        target = e.target.parentElement;
                    }
                    var audioIndex = parseInt(target.getElementsByClassName('aplayer-list-index')[0].innerHTML) - 1;
                    if (audioIndex !== _this2.player.playIndex) {
                        _this2.player.switchAudio(audioIndex);
                        _this2.player.play();
                    } else {
                        _this2.player.toggle();
                    }
                });
            }
        },
        {
            key: 'initPlayBar',
            value: function initPlayBar() {
                var _this3 = this;
                var thumbMove = function thumbMove(e) {
                    var percentage = ((e.clientX || e.changedTouches[0].clientX) - _utils2.default.getElementViewLeft(_this3.player.template.barWrap)) / _this3.player.template.barWrap.clientWidth;
                    percentage = Math.max(percentage, 0);
                    percentage = Math.min(percentage, 1);
                    _this3.player.bar.set('played', percentage, 'width');
                    _this3.player.lrc && _this3.player.lrc.update(percentage * _this3.player.audio.duration);
                    _this3.player.template.ptime.innerHTML = _utils2.default.secondToTime(percentage * _this3.player.audio.duration);
                };
                var thumbUp = function thumbUp(e) {
                    document.removeEventListener(_utils2.default.nameMap.dragEnd, thumbUp);
                    document.removeEventListener(_utils2.default.nameMap.dragMove, thumbMove);
                    var percentage = ((e.clientX || e.changedTouches[0].clientX) - _utils2.default.getElementViewLeft(_this3.player.template.barWrap)) / _this3.player.template.barWrap.clientWidth;
                    percentage = Math.max(percentage, 0);
                    percentage = Math.min(percentage, 1);
                    _this3.player.bar.set('played', percentage, 'width');
                    _this3.player.seek(_this3.player.bar.get('played', 'width') * _this3.player.audio.duration);
                    _this3.player.timer.enable('progress');
                };
                this.player.template.barWrap.addEventListener(_utils2.default.nameMap.dragStart, function () {
                    _this3.player.timer.disable('progress');
                    document.addEventListener(_utils2.default.nameMap.dragMove, thumbMove);
                    document.addEventListener(_utils2.default.nameMap.dragEnd, thumbUp);
                });
            }
        },
        {
            key: 'initVolumeButton',
            value: function initVolumeButton() {
                var _this4 = this;
                this.player.template.volumeButton.addEventListener('click', function () {
                    if (_this4.player.audio.muted) {
                        _this4.player.audio.muted = false;
                        _this4.player.switchVolumeIcon();
                        _this4.player.bar.set('volume', _this4.player.volume(), 'height');
                    } else {
                        _this4.player.audio.muted = true;
                        _this4.player.switchVolumeIcon();
                        _this4.player.bar.set('volume', 0, 'height');
                    }
                });
                var thumbMove = function thumbMove(e) {
                    var percentage = 1 - ((e.clientY || e.changedTouches[0].clientY) - _utils2.default.getElementViewTop(_this4.player.template.volumeBar)) / _this4.player.template.volumeBar.clientHeight;
                    percentage = Math.max(percentage, 0);
                    percentage = Math.min(percentage, 1);
                    _this4.player.volume(percentage);
                };
                var thumbUp = function thumbUp(e) {
                    _this4.player.template.volumeBarWrap.classList.remove('aplayer-volume-bar-wrap-active');
                    document.removeEventListener(_utils2.default.nameMap.dragEnd, thumbUp);
                    document.removeEventListener(_utils2.default.nameMap.dragMove, thumbMove);
                    var percentage = 1 - ((e.clientY || e.changedTouches[0].clientY) - _utils2.default.getElementViewTop(_this4.player.template.volumeBar)) / _this4.player.template.volumeBar.clientHeight;
                    percentage = Math.max(percentage, 0);
                    percentage = Math.min(percentage, 1);
                    _this4.player.volume(percentage);
                };
                this.player.template.volumeBarWrap.addEventListener(_utils2.default.nameMap.dragStart, function () {
                    _this4.player.template.volumeBarWrap.classList.add('aplayer-volume-bar-wrap-active');
                    document.addEventListener(_utils2.default.nameMap.dragMove, thumbMove);
                    document.addEventListener(_utils2.default.nameMap.dragEnd, thumbUp);
                });
            }
        },
        {
            key: 'initOrderButton',
            value: function initOrderButton() {
                var _this5 = this;
                this.player.template.order.addEventListener('click', function () {
                    if (_this5.player.options.order === 'list') {
                        _this5.player.options.order = 'random';
                        _this5.player.template.order.innerHTML = _icons2.default.orderRandom;
                    } else if (_this5.player.options.order === 'random') {
                        _this5.player.options.order = 'list';
                        _this5.player.template.order.innerHTML = _icons2.default.orderList;
                    }
                });
            }
        },
        {
            key: 'initLoopButton',
            value: function initLoopButton() {
                var _this6 = this;
                this.player.template.loop.addEventListener('click', function () {
                    if (_this6.player.isMultiple()) {
                        if (_this6.player.options.loop === 'one') {
                            _this6.player.options.loop = 'none';
                            _this6.player.template.loop.innerHTML = _icons2.default.loopNone;
                        } else if (_this6.player.options.loop === 'none') {
                            _this6.player.options.loop = 'all';
                            _this6.player.template.loop.innerHTML = _icons2.default.loopAll;
                        } else if (_this6.player.options.loop === 'all') {
                            _this6.player.options.loop = 'one';
                            _this6.player.template.loop.innerHTML = _icons2.default.loopOne;
                        }
                    } else {
                        if (_this6.player.options.loop === 'one' || _this6.player.options.loop === 'all') {
                            _this6.player.options.loop = 'none';
                            _this6.player.template.loop.innerHTML = _icons2.default.loopNone;
                        } else if (_this6.player.options.loop === 'none') {
                            _this6.player.options.loop = 'all';
                            _this6.player.template.loop.innerHTML = _icons2.default.loopAll;
                        }
                    }
                });
            }
        },
        {
            key: 'initMenuButton',
            value: function initMenuButton() {
                var _this7 = this;
                this.player.template.list.style.height = 33 * this.player.options.audio.length - 1 + 'px';
                this.player.template.menu.addEventListener('click', function () {
                    if (!_this7.player.template.list.classList.contains('aplayer-list-hide')) {
                        _this7.player.template.list.classList.add('aplayer-list-hide');
                    } else {
                        _this7.player.template.list.classList.remove('aplayer-list-hide');
                    }
                });
            }
        }
    ]);
    return Controller;
}();
exports.default = Controller;


//////////////////
// WEBPACK FOOTER
// ./src/js/controller.js
// module id = 32
// module chunks = 0